export default "__VITE_ASSET__B6qw2oHX__"